export default __webpack_public_path__ + "static/media/rsr.1ff249a4.svg";